import React,  { useState } from "react";
import "../../styles/WallTiles.css";
import { Link } from "react-router-dom";
import img1 from "../../images/waterproofspc/Stair_nosings.jpg";
// import img2 from "../../images/laminates/8mm/img2.jpg";
// import img3 from "../../images/laminates/8mm/img3.jpg";
// import img4 from "../../images/laminates/8mm/img4.jpg";
// import img5 from "../../images/laminates/8mm/img5.jpg";
const StairNosings = () => {
   const productData = {
      names: ["TIGER FREE", "TIGER WAMP", "TIGER QUEEZE", "TIGER QUEST","TIGER GRAND","TIGER BROKE","LION 'NO CAP' and GRIZZLY 'SWAG'","LION 'BRO' and GRIZZLY 'FLY' ","LION 'SIMP' and GRIZZLY 'BUG' ","LION 'SNITCH' and GRIZZLY 'BUZZ'"],
      
      categories: ["Stair Nossings", "Stair Nossings", "Stair Nossings", "Stair Nossings","Stair Nossings","Stair Nossings","Stair Nossings","Stair Nossings","Stair Nossings","Stair Nossings"],
      // text: [
      //   "SPC Flooring",
      //   "Durable Laminate",
      //   "Luxury Vinyl Plank",
      //   "Hybrid Flooring",
      //   "Engineered Wood Plank"
      // ]
    };
  
    // Array of 5 color options
    const colorOptions = [
      "https://www.bearfoot.ie/assets/waterproof-spc/stair-nosings/stair-nosings/tiger-free/FREE__FocusFillWzU2MCwzOTIsIngiLDEwMV0.jpg",
      "https://www.bearfoot.ie/assets/waterproof-spc/stair-nosings/stair-nosings/tiger-wamp/WAMP__FocusFillWzU2MCwzOTIsIngiLDEwMV0.jpg",
      "https://www.bearfoot.ie/assets/waterproof-spc/stair-nosings/stair-nosings/tiger-squeeze/SQUEEZE__FocusFillWzU2MCwzOTIsIngiLDEwMV0.jpg",
      "https://www.bearfoot.ie/assets/waterproof-spc/stair-nosings/stair-nosings/tiger-quest/QUEST__FocusFillWzU2MCwzOTIsIngiLDEwMV0.jpg",
      "https://www.bearfoot.ie/assets/waterproof-spc/stair-nosings/stair-nosings/tiger-grand/GRAND-CANYON__FocusFillWzU2MCwzOTIsIngiLDEwMV0.jpg",
      "https://www.bearfoot.ie/assets/waterproof-spc/stair-nosings/stair-nosings/tiger-broke/BROKE__FocusFillWzU2MCwzOTIsIngiLDEwMV0.jpg",
      "https://www.bearfoot.ie/assets/waterproof-spc/stair-nosings/stair-nosings/new-product-details/NO-CAP-SWAG__FocusFillWzU2MCwzOTIsIngiLDEwMV0.jpg",
      "https://www.bearfoot.ie/assets/waterproof-spc/stair-nosings/stair-nosings/new-product-details/BRO-FLY__FocusFillWzU2MCwzOTIsIngiLDEwMV0.jpg",
      "https://www.bearfoot.ie/assets/waterproof-spc/stair-nosings/stair-nosings/lion-simp-and-grizzly-bug/SIMP-BUG__FocusFillWzU2MCwzOTIsIngiLDEwMV0.jpg",
      "https://www.bearfoot.ie/assets/waterproof-spc/stair-nosings/stair-nosings/new-product-details/SNITCH-BUZZ__FocusFillWzU2MCwzOTIsIngiLDEwMV0.jpg",
     
    ];
  
    const [currentImage, setCurrentImage] = useState(colorOptions[0]);
    const [currentIndex, setCurrentIndex] = useState(0);
  
    const handleColorClick = (colorImage, idx) => {
      setCurrentImage(colorImage);
      setCurrentIndex(idx);
    };
  return (
    <>
      <div className="tile1">
        <div className="text">
          <div className="first">
            <p className="second">
              <h1>Stair Nosings</h1>
              Waterproof SPC (Stone Plastic Composite) flooring is a game-changer for moisture-prone 
              areas, as it is 100% waterproof and impervious to water damage. Its rigid core construction
              provides exceptional durability and stability, resisting warping, cracking, and buckling even 
              in extreme conditions. SPC flooring combines the beauty of wood-like designs with unparalleled 
              practicality, making it suitable for bathrooms, kitchens, and basements. Easy to install with 
              click-and-lock systems, it also requires minimal maintenance, saving time and effort in cleaning. 
              Moreover, it is highly scratch-resistant and pet-friendly, offering a long-lasting and cost-effective
              flooring solution for households and commercial spaces alike.
            </p>
            
            <div className="img-link">           
             <Link to='/SPC_Stair'>
              <img src={img1} alt="Laminate Tile 1" className="main_image" />
              {/* <div className="img-info">
                  <p>Click Image to see More</p>
               </div> */}
            </Link>
            </div>
          </div>
           
        </div>
      </div>
      <div className="product-detail">
                {/* <Link to="/stair_nosings" className="back-link">
                  Back
                </Link> */}
                <div className="product-main">
                  <img
                    className="main-product-image"
                    src={currentImage}
                    alt={productData.names[currentIndex]}
                    style={{
                      width: "300px",
                      height: "300px",
                      border: "1px solid #ddd",
                      marginBottom: "10px",
                    }}
                  />
                  <div className="product-info">
                    <h2>{productData.names[currentIndex]}</h2>
                    {/* <strong>{productData.descriptions[currentIndex]}</strong> */}
                    <h5>Category: {productData.categories[currentIndex]}</h5>
                    {/* <p>{productData.text[currentIndex]}</p> */}
          
                    <div className="colors">
                      {colorOptions.map((colorImage, idx) => (
                        <div
                          key={idx}
                          className="color-swatch"
                          onClick={() => handleColorClick(colorImage, idx)}
                          style={{
                            cursor: "pointer",
                            display: "inline-block",
                            margin: "2px",
                          }}
                        >
                          <img
                            src={colorImage}
                            alt={`Color Option ${idx + 1}`}
                            style={{
                              width: "70px",
                              height: "70px",
                              border: currentIndex === idx ? "2px solid blue" : "2px solid #ddd",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div> 
      {/* <div className="container">
        <div className="tile">
          <div className="image">
            <img src={img2} alt="Laminate Tile 2" />
          </div>
        </div>

        <div className="tile">
          <div className="image">
            <img src={img3} alt="Laminate Tile 3" />
          </div>
        </div>

        <div className="tile">
          <div className="image">
            <img src={img4} alt="Laminate Tile 4" />
          </div>
        </div>

        <div className="tile">
          <div className="image">
            <img src={img5} alt="Laminate Tile 5" />
          </div>
        </div>
      </div> */}
    </>
  );
};

export default StairNosings;
